export default function SmartColour(colour) {
  let response = {
    background: "white",
    text: "black",
    link: "teal",
    classes: "bg-white text-black",
  };

  if (!colour) return response;

  if (colour === "black") {
    response.background = "black";
    response.text = "white";
    response.link = "gold";
    response.classes = "bg-black text-white";
  }

  return response;
}
